import { render } from "./EncodingLoader.vue?vue&type=template&id=a8c59ea2&scoped=true"
const script = {}

import "./EncodingLoader.vue?vue&type=style&index=0&id=a8c59ea2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c59ea2"]])

export default __exports__